import * as angular from "angular";

let NoSearchResultsComponent = {
    selector: "vcNoSearchResults",
    templateUrl:
        "/angular/components/help-text/no-search-results.component.html",
    bindings: {
        supportDocLink: "=?",
    },
    controller: class NoSearchResultsController {
        // * bindings for typescript compiler *
        public supportDocLink?: string;
        // ************************************
    },
};

angular
    .module("helpText")
    .component(NoSearchResultsComponent.selector, NoSearchResultsComponent);
